import React, { useState, useRef, useCallback, useMemo } from "react";
import { useEffect } from "react";
import {
  Col,
  Overlay,
  OverlayTrigger,
  Popover,
  Row,
  Tooltip,
} from "react-bootstrap";
import * as commonData from "../../Common";
import EditField from "./EditField";
import useHideShowDropDown from "../../helpers/hideshowdropdown";
import httpAxios from "../../http-axios";
import { useDispatch } from "react-redux";
import Modal from "../UI/modal/Modal";
import Button from "../UI/Button";
import action from "../../Actions";
import Message from "../UI/Message";
import useValidate from "./useValidation";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import ReactSelectAsync from "react-select/async";
import Error from "../Error";
import ImagePreview from "../UI/ImagePreview";
import DateTimeDisplay from "../../utils/TimeZoneDisplay";
import { checkEffortHandler } from "../../utils/utility";
import ReactSelect, { components } from "react-select";
import PopOver from "../PopOver";

const parseDependencies = (dependencies) => {
  if (typeof dependencies !== "string") {
    return dependencies;
  }

  try {
    return JSON.parse(dependencies);
  } catch (e) {
    return dependencies;
  }
};

const isTruthyDependencyFlag = (value) => {
  if (value === true || value === 1) {
    return true;
  }

  if (typeof value === "string") {
    return ["true", "1", "yes"].includes(value.trim().toLowerCase());
  }

  return false;
};

const hasConfiguredDependencies = (dependencies) => {
  const parsedDependencies = parseDependencies(dependencies);

  if (Array.isArray(parsedDependencies)) {
    return parsedDependencies.length > 0;
  }

  if (parsedDependencies && typeof parsedDependencies === "object") {
    return Object.keys(parsedDependencies).length > 0;
  }

  return false;
};

const checkHasDependencies = (item) => {
  return (
    isTruthyDependencyFlag(item?.has_dependencies) ||
    isTruthyDependencyFlag(item?.has_dependency) ||
    isTruthyDependencyFlag(item?.hasDependencies) ||
    hasConfiguredDependencies(item?.dependencies)
  );
};

const ReadOnlyField = (props) => {
  const params = useParams();
  const editRef = useRef(null);
  const setSingle = useRef({});
  const [dataState, setDataState] = useState(props);
  const [isEdit, setIsEdit] = useState(false);
  const [singleEdit, setSingleEdit] = useState({});
  const dispatch = useDispatch();
  const [isDelete, setIsDelete] = useState(false);
  const [deleId, setDeleId] = useState("");
  const [boardData, setBoardData] = useState(props.boarddata || {});
  const { validateError, validate } = useValidate();
  const [timer, setTimer] = useState("");
  const [freeze, setFreeze] = useState(true);
  const [allOptions, setAlloptions] = useState([]);
  const [showErModal, setShowErModal] = useState(false);
  const [status, setStatus] = useState({});
  const [isShow, setIsShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [useroptions, setUseroptions] = useState([]);
  const [propsMonitor, setPropsMonitor] = useState(null);
  const [multiSelect, setMultiSelect] = useState({});
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [isPodPopoverVisible, setIsPodPopoverVisible] = useState({});
  const [state, setState] = useState({
    tagging: [],
    users: {},
  });

  const [customerErrorsSetup, setCustomerErrorsSetup] = useState({});

  const [message, setMessage] = useState({
    board: false,
    title: "",
    message: "",
    position: "bottom-end",
    bg: "",
  });
  const [erValues, setErValues] = useState([]);
  const ref = useRef(null);
  const [errorValidationcheck, seterrorValidationcheck] = useState({
    isValid: true,
    message: "",
  });
  const memoizedData = useMemo(() => {
    // Perform expensive computation on data
    return props.users || {};
  }, [props.users]);
  useEffect(() => {
    setStatus(props.status);
  }, [props.status]);

  useEffect(() => {
    const valuetoSet =
      props.attribute_type === "project"
        ? Array.isArray(props.rows[props.field])
          ? props.rows[props.field].map((item) => item.id)
          : []
        : props.rows[props.field];

    setErValues(valuetoSet);
  }, [props.field, props.rows]);

  const slaPopover = (
    <Popover id="sla-popover">
      <Popover.Header as="h3">SLA Info</Popover.Header>
      <Popover.Body>
        This field is SLA-highlighted. Hover for more details.
      </Popover.Body>
    </Popover>
  );

  const ImageOption = (props) => {
    const { Option } = components;
    const getimage = props.options.find(
      (item) => item.value === props.value,
    ).profile_image;

    return (
      <Option {...props}>
        <img
          className="rounded-circle rci"
          style={{ width: "20px", height: "20px" }}
          src={`${
            getimage ||
            "data:image/png;base64,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"
          }`}
        />{" "}
        &nbsp;
        {props.data.label}
      </Option>
    );
  };

  const erAsyncCall = (api, evt) => {
    let url = api;
    url += evt ? evt : "";
    return new Promise(async (res, err) => {
      let p = new Promise((res, err) => {
        if (timer) clearTimeout(timer);
        let timerc = setTimeout(async () => {
          setFreeze(false);
          if (evt) {
            const resp = await fetch(url);
            const data = await resp.json();
            if (data.hasOwnProperty("code") && data.code === 200) {
              res(data);
            } else {
              res(data);
            }
          } else {
            if (url !== "undefined") {
              const resp = await fetch(url);
              const data = await resp.json();
              if (data.hasOwnProperty("code") && data.code === 200) {
                const { data: ndata } = data;
                res(data);
              } else {
                res(data);
              }
            }
          }
        }, 2000);

        setTimer(timerc);
      });
      p.then((newd) => {
        if (newd?.hasOwnProperty("data")) {
          const newrecord = newd?.data?.map((item) => {
            return {
              label: `${item.customer_tattle_uuid || item?.transcript_id} - ${
                item.title?.length > 30
                  ? item.title.slice(0, 30) + "..."
                  : item.title
              }`,
              value: item.customer_tattle_uuid || item?.transcript_id,
            };
          });
          setAlloptions(newrecord);
          return res(newrecord);
        } else {
          const neewdata = Object.entries(newd).map(([key, val]) => ({
            label: `${key} -  ${val.title}`,
            value: key,
            url: val.url,
          }));

          setAlloptions(neewdata);
          return res([]);
        }
      });
    });
  };

  useEffect(() => {
    setBoardData(props.boarddata);
  }, [props.boarddata]);

  useEffect(() => {
    setTimeout(() => {
      setDataState(props);
    });

    if (props.attribute_type === "monitoring") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            showInlineEdit: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (
      props.attribute_type === "toggle" ||
      props.attribute_type === "multi-select"
    ) {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            showInlineEdit: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "customer") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "board") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "customer_type") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "account_manager") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: props?.readonly,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "url") {
      const url = dataState.rows[dataState.field];

      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: url ? true : false,
          };
        });
      });
    } else if (props.attribute_type === "company_name") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "name") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "cc") {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly: true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else if (props.attribute_type === "category") {
      const { options } = status;
      let isTrue = options?.find((item) => item.is_default == true)?.is_default;
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            readonly:
              (isTrue && !props.isStatusChanging) ||
              props.currentSelectedStatusName === "New"
                ? false
                : true,
            // errors: { isValid: true, message: "" },
          };
        });
      });
    } else {
      setTimeout(() => {
        setDataState((state) => {
          return {
            ...state,
            ...props,
            errors: { isValid: true, message: "" },
          };
        });
      });
    }
  }, [props, status, dataState.rows]);

  useEffect(() => {
    let newdatastate = { ...dataState };

    newdatastate = {
      ...newdatastate,
      ...customerErrorsSetup[newdatastate.attribute_type],
    };
    setDataState(newdatastate);
  }, [customerErrorsSetup]);

  // useHideShowDropDown(editRef, () => {
  //   if (
  //     dataState?.newerror?.isValid ||
  //     dataState?.newerror?.isValid !== undefined
  //   ) {
  //     dataState.removeAllEditInline();
  //   }
  // });
  const addErHandler = () => {
    if (props.checkError()) setShowErModal(true);
  };

  const convertDateFormat = (date) => {
    let convertdate = moment(date).format("YYYY-MM-DD");
    return convertdate;
  };
  const checkValueNotSame = (date, field) => {
    return date != dataState.rows[field];
  };
  const isDateValidate = (val, dataState, field) => {
    const { start_date, end_date, go_live_date } = dataState.rows;
    let checking = { valid: true, message: "" };
    if (
      field === "start_date" &&
      end_date &&
      new Date(val) > new Date(end_date)
    ) {
      checking.valid = false;
      checking.message = "Start date should not greater than End date";
    }
    if (
      field === "start_date" &&
      go_live_date &&
      new Date(val) > new Date(go_live_date)
    ) {
      checking.valid = false;
      checking.message = "Start date should not greater than Go live date";
    }
    if (
      field === "end_date" &&
      go_live_date &&
      new Date(val) > new Date(go_live_date)
    ) {
      checking.valid = false;
      checking.message = "End date should not greater than Go live date";
    }
    if (
      field === "end_date" &&
      start_date &&
      new Date(val) < new Date(start_date)
    ) {
      checking.valid = false;
      checking.message = "End date should not less than Start date";
    }
    if (
      field === "go_live_date" &&
      end_date &&
      (new Date(val) < new Date(end_date) ||
        new Date(val) < new Date(start_date))
    ) {
      checking.valid = false;
      checking.message = "Go live date should not less than End date";
    }

    return checking;
  };
  const datePickerHandler = (evt, field) => {
    let date = convertDateFormat(evt);
    let data = { [field]: date };
    let statedata = { ...dataState };
    let validation = {};
    if (evt === null) {
      statedata["rows"][field] = "";
      setSingle.current = { [field]: "" };
    } else {
      if (
        dataState["rows"].hasOwnProperty(field) &&
        checkValueNotSame(date, field) &&
        dataState["rows"][field] !== "" &&
        dataState["rows"][field] != null &&
        dataState.show_reason
      ) {
        props.reasonAsking(
          field,
          { ...statedata, ...data },
          dataState.details_pane,
        );
      }

      setSingle.current = { ...setSingle.current, ...data };
    }
  };
  const inputHandleChange = async (ev, namef = null, type = null) => {
    try {
      const statedata = { ...dataState };
      const validation = {};
      if (
        ev.hasOwnProperty(dataState["field"]) &&
        dataState.attribute_type === "effort"
      ) {
        statedata["rows"][dataState.field] = { ...ev?.[dataState["field"]] };
        setSingleEdit((prevState) => ({ ...prevState, ...ev }));
        setSingle.current = { ...setSingle.current, ...ev };

        const newdatastate = { ...statedata, ...validation };
        setDataState(newdatastate);

        return;
      }
      const { name, value } = ev.target;
      if (dataState.attribute_type === "url") {
        let customerErrors = { ...customerErrorsSetup };
        const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
        if (value && !urlRegex.test(value)) {
          validation["message"] = `${dataState.headerName} is invalid`;
          validation["isValid"] = false;
        } else {
          validation["message"] = "";
          validation["isValid"] = true;
        }
        customerErrors = {
          ...customerErrors,
          [dataState.attribute_type]: {
            ...validation,
          },
        };

        setCustomerErrorsSetup(customerErrors);
      }
      let data = { [name]: value };
      if (dataState.attribute_type === "number") {
        if (dataState.is_required && !value) {
          validation["message"] = `${name} is required`;
          validation["isValid"] = false;
        } else if (isNaN(value)) {
          validation["message"] = `please enter a number`;
          validation["isValid"] = false;
        } else if (value && value.includes("-")) {
          validation["message"] = `please enter a number`;
          validation["isValid"] = false;
        } else {
          if (!dataState.is_required && !value) {
            data = { [name]: " " };
          }
          validation["message"] = ``;
          validation["isValid"] = true;
        }
      }

      if (dataState.attribute_type === "text") {
        if (dataState.is_required && !value) {
          validation["message"] = `${name} is required`;
          validation["isValid"] = false;
        } else {
          validation["message"] = ``;
          validation["isValid"] = true;
        }
      }
      if (dataState["rows"][name] !== "" && dataState.show_reason) {
        props.reasonAsking(
          name,
          { ...statedata, ...data },
          dataState.details_pane,
        );
        return;
      }
      statedata["rows"][name] = value;
      // setSingleEdit((prevState) => ({ ...prevState, ...data }));
      setSingle.current = { ...setSingle.current, ...data };
      const newdatastate = { ...statedata, errors: { ...validation } };
      setDataState(newdatastate);
      props.erroSetup(dataState.details_pane, validation);
    } catch (error) {
      console.log(error);
    }
  };
  const reactSelectHandler = (evt, field, multi) => {
    let newarrr = [];
    if (multi) {
      if (Array.isArray(evt) && evt.length > 0) {
        evt.forEach((item) => {
          newarrr.push(item.value.toString());
        });
      } else {
        newarrr = [];
      }
    } else {
      newarrr = evt ? evt.value : "";
    }
    const editData = { [field]: newarrr };

    if (checkHasDependencies(dataState) && props.dependencyAsking) {
      const handled = props.dependencyAsking(
        field,
        editData,
        dataState.details_pane,
        dataState,
        dataState.attribute_type,
      );
      if (handled) {
        setSingleEdit(null);
        setSingle.current = {};
        return;
      }
    }

    if (evt && evt.hasOwnProperty("show_reason") && evt.show_reason) {
      let data = { [field]: evt.value };

      props.reasonAsking(
        field,
        { ...dataState, ...data },
        dataState.details_pane,
        "select",
      );
      return;
    }
    const statedata = { ...dataState };
    if (evt === null) {
      statedata["rows"][field] = "";
      setSingle.current = { [field]: "" };
    }
    try {
      let newarrr = [];
      if (multi) {
        if (evt.length > 0) {
          evt.forEach((item) => {
            newarrr.push(item.value.toString());
          });
        } else {
          newarrr = [];
        }
      } else {
        newarrr = evt.value;
      }
      if (
        dataState["rows"].hasOwnProperty(statedata.field) &&
        dataState["rows"][statedata.field] !== "" &&
        dataState.show_reason
      ) {
        props.reasonAsking(
          statedata.field,
          { ...dataState, [field]: evt.value },
          dataState.details_pane,
        );
        return;
      }
      statedata["rows"][field] = newarrr;
      setSingleEdit((prevState) => ({ ...prevState, [field]: newarrr }));
      setDataState(statedata);
    } catch (error) {
      console.log(error.message);
    }
  };
  const modalSubmitHandler = (val) => {
    if (validateError.isValid === false) {
      props.erroSetup(dataState.details_pane, { ...validateError });
    }
    if (
      dataState?.newerror?.isValid === false ||
      dataState?.errors?.isValid === false
    ) {
      return;
    } else {
      if (checkHasDependencies(dataState) && props.dependencyAsking) {
        const handled = props.dependencyAsking(
          dataState.field,
          val,
          dataState.details_pane,
          dataState,
          dataState.attribute_type,
        );
        if (handled) return;
      }
      dataState.dataSubmit(val, dataState.attribute_type, dataState.field);
    }
  };
  const onBlurHandler = (type = null, val = null, attr = null, data) => {
    if (data?.errors?.isValid === false) {
      props.erroSetup(data?.errors);
      return;
    }
    if (validateError.isValid === false) {
      props.erroSetup(dataState.details_pane, { ...validateError });
    }
    if (
      dataState?.newerror?.isValid === false ||
      dataState?.errors?.isValid === false
    ) {
      return;
    } else {
      const editData =
        Object.keys(setSingle.current).length > 0
          ? setSingle.current
          : singleEdit && Object.keys(singleEdit).length > 0
            ? singleEdit
            : null;

      if (
        editData &&
        checkHasDependencies(dataState) &&
        props.dependencyAsking
      ) {
        const handled = props.dependencyAsking(
          dataState.field,
          editData,
          dataState.details_pane,
          dataState,
          dataState.attribute_type,
          data?.calculate_effort ?? {},
        );
        if (handled) {
          setSingleEdit(null);
          setSingle.current = {};
          seterrorValidationcheck({ isValid: true, message: "" });
          return;
        }
      }

      if (Object.keys(setSingle.current).length > 0) {
        dataState.dataSubmit(
          setSingle.current,
          dataState.attribute_type,
          dataState.field,
          null,
          data?.calculate_effort ?? {},
        );
      } else {
        if (singleEdit && Object.keys(singleEdit).length > 0) {
          dataState.dataSubmit(
            singleEdit,
            dataState.attribute_type,
            dataState.field,
          );
        }
      }
      dataState.removeAllEditInline(type);
      setSingleEdit(null);
      setSingle.current = {};
      seterrorValidationcheck({ isValid: true, message: "" });
    }
  };
  const multiSelectHandler = (data, name) => {
    const newdata = [...new Set(data)];
    const editData = { [name]: newdata };
    if (checkHasDependencies(dataState) && props.dependencyAsking) {
      const handled = props.dependencyAsking(
        name,
        editData,
        dataState.details_pane,
        dataState,
        dataState.attribute_type,
      );
      if (handled) {
        return;
      }
    }
    dataState.dataSubmit(editData, dataState.attribute_type);
  };

  const toggleHandler = (evt) => {
    const { name, value } = evt.target;
    let data = {
      [name]: value === "false" || value === "" ? true : false,
    };
    if (checkHasDependencies(dataState) && props.dependencyAsking) {
      const handled = props.dependencyAsking(
        name,
        data,
        dataState.details_pane,
        dataState,
        dataState.attribute_type,
      );
      if (handled) {
        return;
      }
    }
    dataState.dataSubmit(data, dataState.attribute_type);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      !dataState?.newerror?.isValid &&
      dataState?.newerror?.isValid !== undefined
    ) {
      return;
    } else {
      const editData =
        Object.keys(setSingle.current).length > 0
          ? setSingle.current
          : singleEdit && Object.keys(singleEdit).length > 0
            ? singleEdit
            : null;

      if (
        editData &&
        checkHasDependencies(dataState) &&
        props.dependencyAsking
      ) {
        const handled = props.dependencyAsking(
          dataState.field,
          editData,
          dataState.details_pane,
          dataState,
          dataState.attribute_type,
        );
        if (handled) {
          setSingleEdit(null);
          setSingle.current = {};
          return;
        }
      }
      dataState.dataSubmit(singleEdit);
      dataState.removeAllEditInline();
    }
  };

  const previewImage = (image_url) => {
    const exten = image_url.split(".").pop();
    const checkexten = ["pdf", "docx", "csv"];
    if (!checkexten.includes(exten)) {
      const image_window = window.open("", "_blank");
      image_window.document.write(`
          <html>
            <body>
              <img src=${image_url} alt="Example" height="100%" width="100%">
            </body>
          </html>
    `);
    } else {
      window.open(image_url, "_blank");
    }
  };
  function valueExistsInArray(array, value) {
    for (const item of array) {
      if (item == value) {
        return true;
      }
    }
    return false;
  }

  const editLinkHandler = (dataState) => {
    dataState.readonly = false;
  };
  const getCtegory = (type, isMulti, options = [], item, name) => {
    try {
      if (type == "effort") {
        if (typeof item === "object") {
          return checkEffortHandler(item?.total_hours, options, item) || "";
        }
        return (options && options[item]?.name) || "";
      }
      if (type === "select") {
        if (item !== "undefined" && isMulti) {
          try {
            if (Array.isArray(item)) {
              const tttt = options
                ?.filter((it) => item?.includes(it._id))
                .map((iiio) => iiio?.option_name);
              return tttt?.join(", ");
            } else {
              const tttt =
                options &&
                options
                  ?.filter((it) => it._id == item)
                  .map((iiio) => iiio?.option_name);
              return tttt?.join() || "";
            }
          } catch (error) {
            console.log(error.message);
          }
        } else if (Array.isArray(item)) {
          const tttt = options
            ?.filter((it) => item?.includes(it._id))
            .map((iiio) => iiio?.option_name);

          return tttt?.join();
        } else {
          try {
            return options.find((itt) => itt._id === item)?.option_name || "";
          } catch (err) {
            console.log(err);
          }
        }
      } else if (type === "attachment") {
        const { rows } = dataState;

        if (rows.hasOwnProperty("attachment")) {
          return Object.keys(rows.attachment).map((item) => {
            return (
              <div>
                <ImagePreview
                  headImage={rows.attachment[item]}
                  width="100px"
                  height="58px"
                />
              </div>
            );
          });
        }
        return "";
      } else if (type === "priority") {
        if (item !== "undefined" && isMulti) {
          try {
            if (Array.isArray(item)) {
              const tttt = options
                ?.filter((it) => item?.includes(it._id))
                .map((iiio) => iiio?.option_name);

              return tttt?.join();
            } else {
              const tttt =
                Array.isArray(options) &&
                options
                  ?.filter((it) => it._id == item)
                  .map((iiio) => iiio?.option_name);
              return tttt?.join() || "";
            }
          } catch (error) {
            console.log(error.message);
          }
        } else {
          try {
            return options?.find((itt) => itt._id === item)?.option_name || "";
          } catch (err) {
            console.log(err);
          }
        }
      } else if (type === "board") {
        return (
          <a
            href={`//${process.env.REACT_APP_LOCAL_URL}/tattle/${dataState?.boarddata.parent_attribute_set_key}/${dataState.rows["er"]}`}
            target="_blank"
          >
            {dataState.rows["er"]}
          </a>
        );
      } else if (type === "account_manager") {
        const { account_manager: accountManager } =
          dataState["rows"]?.customers;
        const { options } = dataState;
        const optionsvalue = options?.data;
        const findmanager = optionsvalue.find(
          (it) => it.user_uuid === accountManager,
        );
        return accountManager && typeof accountManager === "string" ? (
          <>
            {findmanager?.name ? (
              <img src={findmanager?.attachment} className="assign_to_class" />
            ) : (
              ""
            )}
            {findmanager?.name}
          </>
        ) : (
          ""
        );
      } else if (type === "sales_manager") {
        const { sales_manager: salesManager } = dataState["rows"]?.customers;
        const { options } = dataState;
        const optionsvalue = options?.data;
        const findmanager = optionsvalue.find(
          (it) => it.user_uuid === salesManager,
        );
        return salesManager && typeof salesManager === "string" ? (
          <>
            {findmanager?.name ? (
              <img src={findmanager?.attachment} className="assign_to_class" />
            ) : (
              ""
            )}
            {findmanager?.name}
          </>
        ) : (
          ""
        );
      } else if (type === "tse_owner") {
        const { tse_owner: tseOwner } = dataState["rows"]?.customers;
        const { options } = dataState;
        const optionsvalue = options?.data;
        const findmanager = optionsvalue.find(
          (it) => it.user_uuid === tseOwner,
        );
        return tseOwner && typeof tseOwner === "string" ? (
          <>
            {findmanager?.name ? (
              <img src={findmanager?.attachment} className="assign_to_class" />
            ) : (
              ""
            )}
            {findmanager?.name}
          </>
        ) : (
          ""
        );
      } else if (type === "customer_type") {
        const { customers } = dataState.rows;
        if (customers) {
          return customers?.key_account == 1 ? (
            // After Mautic Integration customer.customer_type ==> customer.account_type
            <>
              {commonData.firstUpper(customers?.account_type || "")} (
              <a>Key Account</a>)
            </>
          ) : (
            commonData.firstUpper(customers?.account_type || "")
          );
        }
        return null;
      } else if (type === "last_update_since") {
        return item === 0 ? item : item;
      } else if (type === "age") {
        return item === 0 ? item : item;
      } else if (type === "number") {
        return item
          ? typeof item == "string"
            ? item.trim()
            : item
          : dataState.attribute_default_value
            ? dataState.attribute_default_value
            : "";
      } else if (type === "api" || type === "release") {
        try {
          const isPodType =
            name === "pod_department" ||
            name === "pod" ||
            name === "pod/department";

          if (!item) return "";

          // ================= MULTI =================
          if (isMulti && Array.isArray(item)) {
            const matchedItems =
              options?.filter((opt) => valueExistsInArray(item, opt.id)) || [];

            if (!matchedItems.length) return "";

            // ===== POD MULTI =====
            if (isPodType) {
              return (
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                  {matchedItems.map((matched) => {
                    const popover = (
                      <Popover id={`popover-${matched.id}`}>
                        <Popover.Body className="ml-0">
                          <div className="popfooter mt-0">
                            <a
                              href={`${process.env.REACT_APP_INTRANET_URL}viewGroups/${matched?.email}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              View POD
                            </a>
                          </div>
                        </Popover.Body>
                      </Popover>
                    );

                    return (
                      <div
                        key={matched.id}
                        onMouseEnter={() => handlePodPopoverToggle(matched.id)}
                        onMouseLeave={() => handlePodPopoverToggle(matched.id)}
                      >
                        <OverlayTrigger
                          trigger="hover"
                          placement="left"
                          overlay={popover}
                          show={isPodPopoverVisible?.[matched.id]}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              padding: "2px 6px",
                              borderRadius: "4px",
                            }}
                          >
                            {matched?.value}
                          </span>
                        </OverlayTrigger>
                      </div>
                    );
                  })}
                </div>
              );
            }

            // ===== DEFAULT MULTI =====
            return matchedItems
              .map((n) => n?.value)
              .filter(Boolean)
              .join(", ");
          }

          // ================= SINGLE =================
          const matched = options?.find((opt) => opt.id == item);
          if (!matched) return "";

          // ===== POD SINGLE =====
          if (isPodType) {
            const popover = (
              <Popover id="popover-positioned">
                <Popover.Body className="ml-0">
                  <div className="popfooter mt-0">
                    <a
                      href={`${process.env.REACT_APP_INTRANET_URL}viewGroups/${matched?.email}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      View POD
                    </a>
                  </div>
                </Popover.Body>
              </Popover>
            );

            return (
              <div
                onMouseEnter={() => handlePopoverToggle(true)} // Show popover on mouse enter
                onMouseLeave={() => handlePopoverToggle(false)}
              >
                <OverlayTrigger
                  trigger="hover"
                  placement="left"
                  overlay={popover}
                  show={isPopoverVisible}
                >
                  <span style={{ cursor: "pointer", color: "#0d6efd" }}>
                    {matched?.value}
                  </span>
                </OverlayTrigger>
              </div>
            );
          }

          return matched?.value || "";
        } catch (error) {
          console.error("API/Release render error:", error);
          return "";
        }
      } else if (type === "product") {
        const { customers } = dataState.rows;

        if (customers) {
          const { options } = dataState;
          return (
            options.find((item) => item?.id === customers?.product)?.value || ""
          );
        }
        return null;
      } else if (type === "status") {
        return options.find((it) => (it.is_default == true ? it?.name : ""))
          ?.name;
      } else if (type === "name") {
        const { customer_name } = dataState.rows;
        if (customer_name) {
          return commonData.firstUpper(customer_name || "");
        }
        return "";
      } else if (type === "company_name") {
        const {
          customers: {
            company_name,
            product,
            customer_id,
            app_token,
            store_uuid,
          },
        } = dataState.rows;
        return product === "49F37046FCD84520895FC18A4F5BFC8B" && customer_id ? (
          <a
            href={`${process.env.REACT_APP_INTRANET_URL}contact/muvi5_${customer_id}`}
            target={"_blank"}
          >
            {commonData.firstUpper(company_name)}
          </a>
        ) : (
          <a
            href={`${process.env.REACT_APP_INTRANET_URL}contact/${customer_id}`}
            target={"_blank"}
          >
            {commonData.firstUpper(company_name)}
          </a>
        );
      } else if (type === "category") {
        return (
          options.find((it) => (it._id == item ? it?.name : ""))?.name || ""
        );
      } else if (type === "cc") {
        return <span className="cc_class">{item || ""}</span>;
      } else if (type === "assign_to") {
        return memoizedData[item]?.name ? (
          <>
            {memoizedData[item]?.profile_image && (
              <img
                src={memoizedData[item]?.profile_image}
                className="assign_to_class"
              />
            )}
            {memoizedData[item]?.name || ""}
          </>
        ) : (
          ""
        );
      } else if (type === "reporter" || type === "people") {
        return memoizedData[item]?.name ? (
          <>
            {memoizedData[item]?.profile_image && (
              <img
                src={memoizedData[item]?.profile_image}
                className="assign_to_class"
              />
            )}
            {memoizedData[item]?.name || ""}
          </>
        ) : (
          ""
        );
      } else if (type === "url") {
        const url = dataState?.rows[dataState?.field];
        if (url) {
          return (
            <div className="url_edit">
              <a href={`${url}`} target="_blank">
                Link
              </a>
              <span onClick={() => editLinkHandler(dataState)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                >
                  <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
                </svg>
              </span>
            </div>
          );
        }
        return "";
      } else if (type === "monitoring") {
        if (Array.isArray(options)) {
          return options?.find((it) => (it.is_default == true ? it?.name : ""))
            ?.name;
        } else {
          for (let iu in options) {
            if (iu === item) {
              return options[iu].name;
            }
          }
        }
      } else if (name === "completed") {
        return item == "false" ? "No" : "Yes";
      } else if (type === "timestamp") {
        return (
          <>
            <DateTimeDisplay dateTime={new Date(dataState.rows?.[name])} />
          </>
        );
      } else if (type === "customer") {
        const { customer } = dataState.rows;
        return customer ? customer : "";
      } else if (type === "start_date") {
        if (item && item == "0000-00-00") {
          return "";
        } else if (item) {
          return !isNaN(Date.parse(item))
            ? moment(item).format(process.env.REACT_APP_DATE_FORMAT)
            : "";
        } else {
          return "";
        }
      } else if (type === "end_date") {
        if (item && item == "0000-00-00") {
          return "";
        } else if (item) {
          return !isNaN(Date.parse(item))
            ? moment(item).format(process.env.REACT_APP_DATE_FORMAT)
            : "";
        } else {
          return "";
        }
      } else if (type === "go_live_date") {
        if (item && item == "0000-00-00") {
          return "";
        } else if (item) {
          return !isNaN(Date.parse(item))
            ? moment(item).format(process.env.REACT_APP_DATE_FORMAT)
            : "";
        } else {
          return "";
        }
      } else if (type === "project") {
        return typeof item === "object" ? item?.join() : "";
      } else if (type === "date") {
        if (item && item == "0000-00-00") {
          return "";
        } else if (item) {
          return moment(item).format(process.env.REACT_APP_DATE_FORMAT);
        } else {
          return "";
        }
      } else return item || "";
    } catch (error) {
      console.log(error.message);
    }
  };

  const customStyles = {
    multiValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center", // Align items center
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#333", // Customize label color if needed
    }),
  };

  const closeModal = () => {
    setShowErModal(false);
    setIsDelete(false);
  };
  const showReasonHandler = (obj) => {
    props.reasonAsking("effort", { ...dataState }, "details", obj);
  };
  const onErSubmitHandler = (type, ervalues, field, attrType, url = null) => {
    if (attrType == "external_api" && url) {
      dataState.dataSubmit(
        { project: { [field]: ervalues } },
        attrType,
        null,
        url,
      );
      return;
    }
    const statedata = { ...dataState };
    if (ervalues.length > 0) {
      statedata["rows"][field] = ervalues.map((item) => ({ id: item.value }));
      setSingleEdit((prevState) => ({
        ...prevState,
        [field]: ervalues.map((item) => ({ id: item.value })),
      }));
      setDataState(statedata);
      props.submitProjectHandler({ [field]: ervalues }, attrType);
      dataState.removeAllEditInline(type);
      setSingleEdit(null);
    } else {
      props.submitProjectHandler({ [field]: erValues }, attrType);
      dataState.removeAllEditInline(type);
      setSingleEdit(null);
    }
  };

  const submitToolbarEditor = (field, data) => {
    const datasub = { [field]: data };
    dataState.dataSubmit(datasub);
    dataState.removeAllEditInline();
  };
  const checkRenderAsPerType = (dataState) => {
    if (dataState.attribute_type == "external_api") {
      return (
        Array.isArray(dataState.rows[props.field]) &&
        dataState.rows[props.field].map((item, index, titem) => {
          if (index + 1 === titem.length) {
            return (
              <>
                <a href={`${dataState.page_url}${item}`} target="_blank">
                  {item}
                </a>
              </>
            );
          }
          return (
            <>
              <a href={`${dataState.page_url}${item}`} target="_blank">
                {item}
              </a>
              ,
            </>
          );
        })
      );
    }

    return (
      Array.isArray(dataState.rows[props.field]) &&
      dataState.rows[props.field].map((item, index, titem) => {
        return (
          <div key={index} className="ers-item shadow-line">
            <div className="d-flex align-items-center gap-2">
              <a
                href={`//${process.env.REACT_APP_LOCAL_URL}/tattle/${dataState.field}/${item?.id || ""}`}
                target="_blank"
                rel="noopener noreferrer"
                className={item?.is_close ? "closed" : ""}
              >
                {`${item?.id} - ${item?.title ?? item?.title}`}{" "}
              </a>
            </div>
          </div>
        );
      })
    );
  };

  useEffect(() => {
    try {
      const usersObj = props?.users || {}; // fallback to empty object
      const users = Object.keys(usersObj)
        .filter((ite) => usersObj[ite]?.is_active == 1)
        .map((item) => ({
          label: usersObj[item]?.name,
          email: usersObj[item]?.email,
          profile_image: usersObj[item]?.profile_image,
          value: item,
        }));
      setPropsMonitor(users);
    } catch (error) {
      console.log(error);
    }
  }, [props]);

  const getProjectDataHandler = (dataState) => {
    const labelsall =
      Array.isArray(dataState.rows[props.field]) &&
      dataState.rows[props.field].map((item) => ({
        label: item?.id + " - " + item?.title || item,
        value: item?.id || item,
      }));

    const ers = checkRenderAsPerType(dataState);

    let uoptions;
    if (propsMonitor?.length > 0) {
      uoptions = propsMonitor?.map((itt) => ({
        label: itt.label,
        value: itt.value,
        profile_image: itt.profile_image,
      }));
    }

    useEffect(() => {
      if (memoizedData && dataState.rows[props.field]) {
        setUseroptions(
          Object.entries(memoizedData)
            .filter(([key]) =>
              dataState.rows[props.field].includes(String(key)),
            )
            .map(([, value]) => value),
        );
      }
    }, [memoizedData, dataState.rows]);

    const removeHandeler = (id) => {
      dataState.removeItemHandler(id, dataState.field);
    };

    return (
      <>
        <Error>
          <Modal show={showErModal} close={closeModal}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (dataState.attribute_type === "people") {
                  modalSubmitHandler({
                    [dataState.field]: erValues,
                  });
                } else {
                  onErSubmitHandler(
                    dataState.details_pane,
                    erValues,
                    dataState.field,
                    dataState.attribute_type,
                    dataState?.update_api,
                  );
                }
                setShowErModal(false);
              }}
              className="er_form"
            >
              {dataState.attribute_type === "people" ? (
                <ReactSelect
                  options={uoptions}
                  components={{ Option: ImageOption }}
                  classNamePrefix="monitor"
                  value={
                    uoptions
                      ? uoptions.filter((opt) => erValues?.includes(opt.value))
                      : []
                  }
                  isMulti={true}
                  style={customStyles}
                  onChange={(evt) => selectErHandler(evt)}
                  isClearable={false}
                />
              ) : (
                <ReactSelectAsync
                  cacheOptions
                  defaultOptions
                  maxMenuHeight={175}
                  styles={customStyles}
                  defaultValue={labelsall}
                  menuPlacement="auto"
                  isMulti={true}
                  loadOptions={(evt) => erAsyncCall(dataState.api_url, evt)}
                  onChange={(evt) => selectErHandler(evt)}
                />
              )}

              <button type="submit" className="muBtn _blue">
                Submit
              </button>
            </form>
          </Modal>
        </Error>
        <div className="er_add">
          {
            <div className="ers-container">
              <div className="ers-list">
                {dataState.attribute_type !== "people" && ers}
              </div>
              {dataState.show_in_modal && (
                <div className="ers-item shadow-line add-icon-row">
                  <div className="middleright-block">
                    <div className="monitorBox">
                      {dataState.attribute_type === "people" &&
                        useroptions.length > 0 &&
                        [
                          ...new Map(
                            useroptions.map((item) => [item.name, item]),
                          ).values(),
                        ].map((item) => (
                          <PopOver
                            key={item.id}
                            users={props.users}
                            item={item}
                            removeMonitorHandler={removeHandeler}
                          />
                        ))}

                      <OverlayTrigger
                        key={"allboard"}
                        placement={"bottom"}
                        overlay={
                          <Tooltip id={`tooltip-allboard`}>
                            <strong>
                              {dataState.attribute_type === "people"
                                ? "Add People"
                                : `Relate ${props.headerName}`}
                            </strong>
                          </Tooltip>
                        }
                      >
                        {dataState.attribute_type === "people" ? (
                          <div
                            className="addMonitorBox"
                            data-bs-toggle="modal"
                            data-bs-target="#addNewMonitor"
                            onClick={() => addErHandler()}
                          >
                            +
                          </div>
                        ) : (
                          <div
                            className="addMonitorBox"
                            data-bs-toggle="modal"
                            data-bs-target="#addNewMonitor"
                            onClick={() => addErHandler()}
                          >
                            +
                          </div>
                        )}
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              )}
            </div>
          }
        </div>
      </>
    );
  };
  const getPopOverHandler = (dataState, rows) => {
    if (
      dataState.attribute_type === "assign_to" ||
      dataState.attribute_type === "reporter" ||
      dataState.attribute_type === "account_manager"
    ) {
      return (
        <>
          <OverlayTrigger
            trigger="hover"
            placement="left"
            overlay={popoverLeft}
          >
            <span>hover</span>
          </OverlayTrigger>
        </>
      );
    }
  };

  const handlePopoverToggle = (show) => {
    if (show) {
      if (
        memoizedData?.[dataState?.rows[dataState.field]]?.profile_url ||
        dataState?.field === "pod_department"
      ) {
        // if(props.app_token === process.env.REACT_APP_support_app_token){
        setPopoverVisible(true);
        // } else {
        //   setPopoverVisible(false);
        // }
      }
    } else {
      setPopoverVisible(false);
    }
  };
  const handlePodPopoverToggle = (id) => {
    if (isPodPopoverVisible[id]) {
      setIsPodPopoverVisible((prev) => ({ ...prev, [id]: false }));
    } else {
      // Close all other popovers
      const allFalse = {};
      [...new Set(memoizedData.allIds ?? [])].forEach((otherId) => {
        allFalse[otherId] = false;
      });
      // Open this one
      setIsPodPopoverVisible({ ...allFalse, [id]: true });
    }
  };
  const selectErHandler = (evt) => {
    const onlyids = evt.map((itt) => itt.value);
    setErValues(onlyids);
  };

  let getresult;
  let newresult;

  if (!dataState.showInlineEdit) {
    if (dataState.attribute_type === "textarea") {
      getresult = {
        ...(dataState.rows[props.field] ? (
          <span
            onClick={() =>
              !dataState?.readonly &&
              dataState.showInlne(dataState.details_pane, dataState)
            }
            dangerouslySetInnerHTML={{
              __html: dataState.rows[props.field],
            }}
            className="second_span"
          ></span>
        ) : (
          <span
            className="second_span backcheck"
            onClick={() =>
              !dataState?.readonly &&
              errorValidationcheck.isValid &&
              dataState.showInlne(dataState.details_pane, dataState)
            }
          ></span>
        )),
      };
    } else if (dataState.attribute_type === "board") {
      getresult = (
        <a
          href={`//${process.env.REACT_APP_LOCAL_URL}/tattle/${dataState?.boarddata.parent_attribute_set_key}/${dataState.rows["er"]}`}
          target="_blank"
        >
          {dataState.rows["er"]}
        </a>
      );
    } else {
      let popoverLeft = (
        <Popover id="popover-positioned-left">
          <Popover.Header>
            <div className="headerSec">
              <div className="profileimage">
                <img
                  src={
                    memoizedData[dataState?.rows[dataState.field]]
                      ?.profile_image
                  }
                />
              </div>
              <div className="bio-data">
                <div className="profileName">
                  {memoizedData[dataState?.rows[dataState.field]]?.name
                    .charAt(0)
                    .toUpperCase() +
                    memoizedData[dataState?.rows[dataState.field]]?.name.slice(
                      1,
                    )}
                </div>
              </div>
            </div>
          </Popover.Header>
          <Popover.Body>
            <div className="popupbody">
              <div className="bodyemail">
                <span>
                  <i className="fa fa-envelope"></i>
                </span>
                <span>
                  {memoizedData[dataState?.rows[dataState.field]]?.email}
                </span>
              </div>
              {memoizedData[dataState?.rows[dataState.field]]?.is_group !=
                1 && (
                <div className="bodycompany">
                  <span>
                    <i class="fa fa-address-card" aria-hidden="true"></i>
                  </span>
                  <span>
                    {memoizedData[dataState?.rows[dataState.field]]
                      ?.position && (
                      <div className="position">
                        {
                          memoizedData[dataState?.rows[dataState.field]]
                            ?.position
                        }
                      </div>
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="popfooter">
              {memoizedData[dataState?.rows[dataState.field]]?.is_group == 1 ? (
                <a
                  href={
                    memoizedData[dataState?.rows[dataState.field]]?.profile_url
                      ? memoizedData[dataState?.rows[dataState.field]]
                          ?.profile_url
                      : "#"
                  }
                  target="_blank"
                >
                  View Group
                </a>
              ) : (
                <a
                  href={
                    memoizedData[dataState?.rows[dataState.field]]?.profile_url
                      ? memoizedData[dataState?.rows[dataState.field]]
                          ?.profile_url
                      : `${process.env.REACT_APP_INTRANET_URL}viewEmployee/${dataState?.rows[dataState.field]}`
                  }
                  target="_blank"
                >
                  View Profile
                </a>
              )}
            </div>
          </Popover.Body>
        </Popover>
      );
      if (
        dataState.attribute_type === "assign_to" ||
        dataState.attribute_type === "reporter" ||
        (dataState.attribute_type === "people" && !dataState.show_in_modal)
      ) {
        getresult = (
          <>
            <div
              onMouseEnter={() => handlePopoverToggle(true)} // Show popover on mouse enter
              onMouseLeave={() => handlePopoverToggle(false)}
            >
              <OverlayTrigger
                trigger="hover"
                placement="auto"
                show={isPopoverVisible}
                overlay={popoverLeft}
              >
                <span
                  onClick={() =>
                    !dataState?.readonly &&
                    dataState.showInlne(dataState.details_pane, dataState)
                  }
                  className={`second_span ${
                    getCtegory(
                      dataState.attribute_type,
                      dataState.is_multiple,
                      dataState.options,
                      dataState.rows[props.field],
                      dataState.field,
                    ) === "" && "backcheck"
                  }`}
                >
                  {getCtegory(
                    dataState.attribute_type,
                    dataState.is_multiple,
                    dataState.options,
                    dataState.rows[props.field],
                    dataState.field,
                  )}
                </span>
              </OverlayTrigger>
            </div>
          </>
        );
      } else {
        getresult = (
          <>
            <span
              onClick={() => {
                return (
                  !dataState?.readonly &&
                  dataState.showInlne(dataState.details_pane, dataState)
                );
              }}
              className={`second_span ${
                getCtegory(
                  dataState.attribute_type,
                  dataState.is_multiple,
                  dataState.options,
                  dataState.rows[props.field],
                  dataState.field,
                ) === "" && "backcheck"
              }`}
            >
              {getCtegory(
                dataState.attribute_type,
                dataState.is_multiple,
                dataState.options,
                dataState.rows[props.field],
                dataState.field,
              )}
            </span>
          </>
        );
      }
    }
    if (dataState.attribute_type === "attachment") {
      getresult = (
        <span
          className="second_span"
          style={{ display: "flex", gap: 15, flexFlow: "row wrap" }}
        >
          {" "}
          {getCtegory(
            dataState.attribute_type,
            dataState.options,
            dataState.rows[props.field],
          )}
        </span>
      );
    }
    if (
      dataState.attribute_type === "project" ||
      dataState.attribute_type == "external_api" ||
      (dataState.attribute_type == "people" && dataState.show_in_modal)
    ) {
      getresult = getProjectDataHandler(dataState);
    } else if (
      (dataState.attribute_type !== "project" &&
        dataState.attribute_type !== "account_manager" &&
        dataState.attribute_type !== "company_name" &&
        dataState.attribute_type == "effort" &&
        dataState.attribute_type !== "name" &&
        dataState.attribute_type !== "customer_type" &&
        dataState.rows[props.field] === undefined) ||
      dataState.rows[props.field] === "undefined" ||
      dataState.rows[props.field] === "" ||
      dataState.rows[props.field] === " " ||
      (Array.isArray(dataState.rows?.[props.field]) &&
        dataState.rows?.[props.field]?.[0] === "") ||
      dataState.rows?.[props.field]?.length === 0
    ) {
      getresult = (
        <span
          onClick={() =>
            !dataState?.readonly &&
            dataState.showInlne(dataState.details_pane, dataState)
          }
          className="second_span backcheck"
        >
          {" "}
          {getCtegory(
            dataState.attribute_type,
            dataState.options,
            dataState.rows[props.field],
          )}
        </span>
      );
    }
  } else {
    getresult = (
      <span className="editable">
        <form onSubmit={handleSubmit}>
          {dataState.attribute_type === "select" ||
          dataState.attribute_type === "api" ||
          dataState.attribute_type === "release" ||
          dataState.attribute_type === "status" ||
          dataState.attribute_type === "category" ||
          dataState.attribute_type === "assign_to" ||
          dataState.attribute_type === "priority" ||
          dataState.attribute_type === "reporter" ||
          dataState.attribute_type === "customer" ||
          dataState.attribute_type === "account_manager" ||
          dataState.attribute_type === "monitoring" ||
          dataState.attribute_type === "people" ? (
            <Error>
              <EditField
                {...dataState}
                onChange={reactSelectHandler}
                refs={editRef}
                onBlur={(val, type) =>
                  onBlurHandler(
                    dataState.details_pane,
                    val,
                    dataState.attribute_type,
                    dataState,
                  )
                }
                newMonitor={props?.newMonitor}
                users={memoizedData}
                AddMonitorHandler={props.AddMonitorHandler}
                boardData={boardData}
                removeMonitorFromAddMonitor={props.removeMonitorFromAddMonitor}
                {...(dataState.attribute_type === "project" ||
                  (dataState.attribute_type == "external_api" && {
                    getApiCall: erAsyncCall,
                  }))}
              />
            </Error>
          ) : dataState.attribute_type === "start_date" ||
            dataState.attribute_type === "end_date" ||
            dataState.attribute_type === "date" ||
            dataState.attribute_type === "go_live_date" ? (
            <Error>
              <EditField
                {...dataState}
                onChange={datePickerHandler}
                onBlur={() =>
                  onBlurHandler(
                    dataState.details_pane,
                    null,
                    dataState.attribute_type,
                    dataState,
                  )
                }
                boardData={boardData}
                removeMonitorFromAddMonitor={props.removeMonitorFromAddMonitor}
              />
            </Error>
          ) : dataState.attribute_type === "toggle" ? (
            <EditField {...dataState} toggleHandler={toggleHandler} />
          ) : dataState.attribute_type === "multi-select" ? (
            <EditField
              {...dataState}
              toggleHandlerMultiple={multiSelectHandler}
            />
          ) : dataState?.newerror?.isValid === false ? (
            <Error>
              <EditField
                {...dataState}
                onChange={inputHandleChange}
                ongetRawDataHandle={
                  dataState.attribute_type === "textarea"
                    ? submitToolbarEditor
                    : ""
                }
                boardData={boardData}
                removeMonitorFromAddMonitor={props.removeMonitorFromAddMonitor}
              />
            </Error>
          ) : dataState?.newerror?.isValid === true ||
            dataState?.errors?.isValid === true ||
            dataState?.newerror?.isValid === undefined ? (
            <Error>
              <EditField
                {...dataState}
                showReasonHandler={showReasonHandler}
                onChange={inputHandleChange}
                refs={editRef}
                onBlur={() =>
                  onBlurHandler(dataState.details_pane, null, null, dataState)
                }
                ongetRawDataHandle={
                  dataState.attribute_type === "textarea"
                    ? submitToolbarEditor
                    : ""
                }
                boardData={boardData}
                removeMonitorFromAddMonitor={props.removeMonitorFromAddMonitor}
              />
            </Error>
          ) : (
            ""
          )}
        </form>
      </span>
    );
  }

  const getPlanningData = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""}`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
        </div>
        {props.SlaHighlight && (
          <OverlayTrigger
            key={props.headerName}
            placement={"right"}
            overlay={
              <Tooltip
                id={`tooltip-${props.headerName}`}
                className="text-capitalize"
              >
                {props.slaReason}
              </Tooltip>
            }
          >
            <i
              className="fa fa-info-circle ms-1 mt-1"
              style={{ cursor: "pointer" }}
            ></i>
          </OverlayTrigger>
        )}

        <div className={`rightText`}>{getresult}</div>
      </div>
    );
  };
  const getPeopleData = (props) => {
    return (
      <div
        className={`mt-2 mb-2 people_class second_main_class ${props.SlaHighlight ? "sla-highlight" : ""}`}
      >
        <div className="leftText">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
        </div>
        {props.SlaHighlight && props.slaReason && (
          <OverlayTrigger
            key={"status"}
            placement={"right"}
            overlay={
              <Tooltip id={`tooltip-status`} className="text-capitalize">
                {props.slaReason}
              </Tooltip>
            }
          >
            <i
              className="fa fa-info-circle ms-1 mt-1"
              style={{ cursor: "pointer" }}
            ></i>
          </OverlayTrigger>
        )}

        <div className={`rightAssign`}>
          <div className="item">{getresult}</div>
        </div>
      </div>
    );
  };

  const getDetailsData = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""}`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
          {props.SlaHighlight && props.slaReason && (
            <OverlayTrigger
              key={props.headerName}
              placement={"right"}
              overlay={
                <Tooltip
                  id={`tooltip-${props.headerName}`}
                  className="text-capitalize"
                >
                  {props.slaReason}
                </Tooltip>
              }
            >
              <i
                className="fa fa-info-circle ms-1 mt-1"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          )}
        </div>

        <div className={`right-text ${props.className}`}>{getresult}</div>
      </div>
    );
  };
  const getHiddenData = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""}`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
          {props.SlaHighlight && props.slaReason && (
            <OverlayTrigger
              key={props.headerName}
              placement={"right"}
              overlay={
                <Tooltip
                  id={`tooltip-${props.headerName}`}
                  className="text-capitalize"
                >
                  {props.slaReason}
                </Tooltip>
              }
            >
              <i
                className="fa fa-info-circle ms-1 mt-1"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          )}
        </div>
        <div className={`right-text ${props.className}`}>{getresult}</div>
      </div>
    );
  };

  const getDevPaneData = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""}`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
          {props.SlaHighlight && props.slaReason && (
            <OverlayTrigger
              key={props.headerName}
              placement={"right"}
              overlay={
                <Tooltip
                  id={`tooltip-${props.headerName}`}
                  className="text-capitalize"
                >
                  {props.slaReason}
                </Tooltip>
              }
            >
              <i
                className="fa fa-info-circle ms-1 mt-1"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          )}
        </div>

        <div className={`rightText`}>{getresult}</div>
      </div>
    );
  };
  const getQaPaneData = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""}`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
          {props.SlaHighlight && props.slaReason && (
            <OverlayTrigger
              key={props.headerName}
              placement={"right"}
              overlay={
                <Tooltip
                  id={`tooltip-${props.headerName}`}
                  className="text-capitalize"
                >
                  {props.slaReason}
                </Tooltip>
              }
            >
              <i
                className="fa fa-info-circle ms-1 mt-1"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          )}
        </div>

        <div className={`rightText`}>{getresult}</div>
      </div>
    );
  };
  const getScrumPaneData = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""}`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
          {props.SlaHighlight && props.slaReason && (
            <OverlayTrigger
              key={props.headerName}
              placement={"right"}
              overlay={
                <Tooltip
                  id={`tooltip-${props.headerName}`}
                  className="text-capitalize"
                >
                  {props.slaReason}
                </Tooltip>
              }
            >
              <i
                className="fa fa-info-circle ms-1 mt-1"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          )}
        </div>

        <div className={`rightText`}>{getresult}</div>
      </div>
    );
  };

  const getReleasePane = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""} mb-2`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
          {props.SlaHighlight && props.slaReason && (
            <OverlayTrigger
              key={props.headerName}
              placement={"right"}
              overlay={
                <Tooltip
                  id={`tooltip-${props.headerName}`}
                  className="text-capitalize"
                >
                  {props.slaReason}
                </Tooltip>
              }
            >
              <i
                className="fa fa-info-circle ms-1 mt-1"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          )}
        </div>

        <div className={`rightText`}>{getresult}</div>
      </div>
    );
  };

  const getFeaturessData = (props) => {
    return (
      <div
        className={`second_main_class mb-2 ${props.SlaHighlight ? "sla-highlight" : ""} ${
          props.className ? props.className : ""
        }`}
      >
        <div className="leftText redonly">
          {commonData.firstUpper(
            props.headerName || props.attribute_label || "",
          )}
          {props.SlaHighlight && props.slaReason && (
            <OverlayTrigger
              key={props.headerName}
              placement={"right"}
              overlay={
                <Tooltip
                  id={`tooltip-${props.headerName}`}
                  className="text-capitalize"
                >
                  {props.slaReason}
                </Tooltip>
              }
            >
              <i
                className="fa fa-info-circle ms-1 mt-1"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          )}
        </div>

        <div className={`right-text ${props.className}`}>{getresult}</div>
      </div>
    );
  };
  return (
    <>
      {message.board && <Message board={message} />}
      {props.type === "planning_date" && getPlanningData(props)}
      {props.type === "people" && getPeopleData(props)}
      {props.type === "details" && getDetailsData(props)}
      {props.type === "feature" && getFeaturessData(props)}
      {props.type === "dev_project_plan" && getDevPaneData(props)}
      {props.type === "release_pane" && getReleasePane(props)}
      {props.type === "qa_project_plan" && getQaPaneData(props)}
      {props.type === "scrum_project_plan" && getScrumPaneData(props)}
      {props.type === "hidden_panel" && getHiddenData(props)}
    </>
  );
};

export default React.memo(ReadOnlyField);
